import { render, staticRenderFns } from "./SubmittedProjects.vue?vue&type=template&id=3b2d64dc"
import script from "./SubmittedProjects.vue?vue&type=script&lang=js"
export * from "./SubmittedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports